module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/asignar-supernet/asignar-supernet.component.css
// module id = ./src/app/asignar-supernet/asignar-supernet.component.css
// module chunks = main